import CardContent from "@mui/material/CardContent";
import React, { useContext } from "react";
import EyeBrow from '../../commonComponents/eyeBrow/eyeBrow';
import { AnnouncementsCardStyled }from './announcementsCard.style';
import { ThemeContext } from 'styled-components';
import { Tooltip } from "@mui/material";
import { handleKeyPress } from "utils/functions";

export interface IAnnouncementsCardProps{
    title?: any;
    eyebrowTitle?: any;
    content?: any;
    handleClick?: () => void;
    kbNumber?: any;
    minHeight?: string;
};

const AnnouncementsCard = (props: IAnnouncementsCardProps) =>{
  const theme = useContext(ThemeContext);
  const { title, eyebrowTitle, content, handleClick, minHeight} = props;

  const clearSelection = () => {
    const selection = window.getSelection();
    if (selection) {
      selection.empty();
    }
  };

  return (
    <AnnouncementsCardStyled
      tabIndex={0}
      onClick={handleClick}
      onDragStart={clearSelection}
      onKeyDown={(e: any) => handleKeyPress(e, "Enter", handleClick)}
    >
      <CardContent className="announcements-card-body">
          <div className="announcements-card-header">
            <EyeBrow
              minHeight={minHeight}
              color={theme.uptimeColors.newsKnowledgeColors.eyeBrow.announcements.color}
              backgroundColor={theme.uptimeColors.newsKnowledgeColors.eyeBrow.announcements.background}
              text={eyebrowTitle}
              id="chp-announcementscard-status"
            />
          </div>
          <Tooltip title={title} arrow placement="bottom-start">
            <div className="announcements-card-title select-all-text" id="lbl-announcementscard-title" aria-label={title}>{title}</div>
          </Tooltip>
          <div className="announcements-card-content select-all-text" id="lbl-announcementscard-content">{content}</div>
      </CardContent>
    </AnnouncementsCardStyled>
  )
};
export const defaultProps = {
  minHeight: '18px',
  eyebrowTitle: "Announcements",
  title: "Pulse VPN updates coming soon. PC restart required.",
  content: "A new version of Pulse VPN (version 9.1.12) will be available on Aug. 17, 2021 for install following the steps below.DXC IT will push the Pulse VPN update to PCs beginning on Aug. 24. Please note:When..."
};
AnnouncementsCard.defaultProps = defaultProps;

export default AnnouncementsCard;